"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDriversCompanySuitableForVehicleType = exports.isCompanyDriverSuitableForVehicleType = exports.isDriverSuitableForVehicleType = exports.determineSuitableVehicleTypesForDriversCompany = exports.determineSuitableVehicleTypesForCompanyDriver = exports.determineSuitableVehicleTypesForDriver = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const determineSuitableVehicleTypes = (willingToDoLite, suitableForLuxury) => {
    const driverVehicleTypes = [legacy_enums_1.VehicleType.Sedan, legacy_enums_1.VehicleType.Mpv, legacy_enums_1.VehicleType.Van, legacy_enums_1.VehicleType.Shuttle];
    if (suitableForLuxury) {
        driverVehicleTypes.push(legacy_enums_1.VehicleType.LuxurySedan);
    }
    if (willingToDoLite) {
        driverVehicleTypes.push(...legacy_enums_1.LiteVehicleTypes);
    }
    return driverVehicleTypes;
};
const determineSuitableVehicleTypesForDriver = ({ driver }) => {
    if (!driver.canSpeakEnglish) {
        return [...legacy_enums_1.LiteVehicleTypes];
    }
    return determineSuitableVehicleTypes(driver.willingToDoLite, driver.isSuitableForLuxury);
};
exports.determineSuitableVehicleTypesForDriver = determineSuitableVehicleTypesForDriver;
const determineSuitableVehicleTypesForCompanyDriver = ({ driver, driversCompany }) => {
    if (!driver.canSpeakEnglish) {
        return driversCompany.willingToDoLite ? [...legacy_enums_1.LiteVehicleTypes] : [];
    }
    // Willingness to rent luxury sedan doesn't matter for company drivers
    return determineSuitableVehicleTypes(driversCompany.willingToDoLite, driver.isSuitableForLuxury);
};
exports.determineSuitableVehicleTypesForCompanyDriver = determineSuitableVehicleTypesForCompanyDriver;
const determineSuitableVehicleTypesForDriversCompany = ({ driversCompany, companyDrivers }) => {
    if (companyDrivers.length === 0) {
        return [];
    }
    const hasEnglishSpeakingDriver = companyDrivers.some((driver) => driver.canSpeakEnglish);
    if (!hasEnglishSpeakingDriver) {
        return driversCompany.willingToDoLite ? [...legacy_enums_1.LiteVehicleTypes] : [];
    }
    const hasSuitableForLuxuryDriver = companyDrivers.some(({ isSuitableForLuxury, canSpeakEnglish }) => canSpeakEnglish && isSuitableForLuxury);
    return determineSuitableVehicleTypes(driversCompany.willingToDoLite, hasSuitableForLuxuryDriver);
};
exports.determineSuitableVehicleTypesForDriversCompany = determineSuitableVehicleTypesForDriversCompany;
const isDriverSuitableForVehicleType = ({ driver, vehicleType }) => {
    return (0, exports.determineSuitableVehicleTypesForDriver)({ driver }).includes(vehicleType);
};
exports.isDriverSuitableForVehicleType = isDriverSuitableForVehicleType;
const isCompanyDriverSuitableForVehicleType = ({ driver, driversCompany, vehicleType, }) => {
    return (0, exports.determineSuitableVehicleTypesForCompanyDriver)({ driver, driversCompany }).includes(vehicleType);
};
exports.isCompanyDriverSuitableForVehicleType = isCompanyDriverSuitableForVehicleType;
const isDriversCompanySuitableForVehicleType = ({ driversCompany, companyDrivers, vehicleType, }) => {
    return (0, exports.determineSuitableVehicleTypesForDriversCompany)({ driversCompany, companyDrivers }).includes(vehicleType);
};
exports.isDriversCompanySuitableForVehicleType = isDriversCompanySuitableForVehicleType;
//# sourceMappingURL=driverSuitabilityForVehicleTypes.js.map